dmx.Component('form', {

    tag: 'form',

    attributes: {
        novalidate: {
            type: Boolean,
            default: false
        }
    },

    methods: {
        submit: function(direct) {
            if (direct) {
                this._submit();
            } else {
                this.submit();
            }
        },

        reset: function() {
            this.reset();
        },

        validate: function() {
            this.validate();
        }
    },

    events: {
        invalid: Event, // when form validation failed
        submit: Event // on form submit (can cancel submit)
    },

    render: function(node) {
        dmx.BaseComponent.prototype.render.call(this, node);
        this.$node.noValidate = true;
        this.$node.addEventListener('submit', this.onsubmit.bind(this));
        this.$node.addEventListener('reset', this.onreset.bind(this));
    },

    submit: function(data) {
        if (this.props.novalidate || this.validate()) {
            if (this.dispatchEvent('submit', { cancelable: true })) {
                this._submit();
            }
        } else {
            dmx.requestUpdate();
            this.dispatchEvent('invalid');
            var elm = dmx.array(this.$node.elements).find(function(elm) {
              if (!elm.validity.valid) return true;
            });
            if (elm) {
              elm.focus();
            }
        }
    },

    _submit: function() {
        //this.$node.submit();
        HTMLFormElement.prototype.submit.call(this.$node);
    },

    reset: function() {
        //this.$node.reset();
        HTMLFormElement.prototype.reset.call(this.$node);
    },

    validate: function() {
        return dmx.validate(this.$node);
    },

    onsubmit: function(event) {
        event.preventDefault();
        this.submit();
    },

    onreset: function(event) {
        dmx.validateReset(this.$node);
        if (window.grecaptcha) {
            grecaptcha.reset();
        }
        dmx.requestUpdate();
    }

});
